import { AttachFile } from '@mui/icons-material';
import { Box, IconButtonProps } from '@mui/material';
import React from 'react';
import { DropzoneState } from 'react-dropzone';
import { StyledIconButton } from './commentInput.style';

interface AttachmentIconButtonProps extends IconButtonProps {
  dropzoneState: DropzoneState;
  setIsOpenAttachment?: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenAttachment?: boolean;
}

const AttachmentIconButton = ({ dropzoneState, isOpenAttachment, setIsOpenAttachment, ...iconButtonProps }: AttachmentIconButtonProps) => {
  const { getRootProps, getInputProps } = dropzoneState;

  const handleOpenAttachment = (e: any) => {
    if (!setIsOpenAttachment) return;
    e.stopPropagation();
    setIsOpenAttachment?.((prev: boolean) => !prev);
  };

  return (
    <Box {...getRootProps()}>
      <input {...getInputProps()} />
      <StyledIconButton isOpenAttachment={isOpenAttachment} disableRipple {...iconButtonProps} onClick={(e: any) => handleOpenAttachment(e)} aria-label='Attachment icon button' id="btn-comment-attach">
        <AttachFile sx={{ width: 20, transform: 'rotate(45deg)' }} />
      </StyledIconButton>
    </Box>
  );
};

export default AttachmentIconButton;
